/**
 * Format seconds as MM:SS or HH:MM:SS
 */
export function formatTime(seconds) {
  if (!seconds || seconds < 0) return '0:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(secs)}`;
  }
  return `${minutes}:${pad(secs)}`;
}

/**
 * Parse MM:SS or HH:MM:SS time string to seconds
 */
export function parseTime(timeString) {
  if (!timeString) return 0;

  const parts = timeString.split(':').map(Number);

  if (parts.length === 2) {
    // MM:SS
    return parts[0] * 60 + parts[1];
  } else if (parts.length === 3) {
    // HH:MM:SS
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }

  return 0;
}

/**
 * Parse duration string (HH:MM:SS or seconds) to seconds
 */
export function parseDuration(duration) {
  if (!duration) return 0;

  // If it's already a number, return it
  if (typeof duration === 'number') return duration;

  // If it contains colons, parse as time string
  if (duration.includes(':')) {
    return parseTime(duration);
  }

  // Otherwise parse as integer seconds
  return parseInt(duration, 10) || 0;
}

/**
 * Zero-pad a number to 2 digits
 */
function pad(num) {
  return String(num).padStart(2, '0');
}
